import { Box, Tooltip } from "@mui/material"
import { FixedNumber } from "ethers"
import React from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import Text from "src/components/Text"
import { XFER } from "src/constants"
import { BIG_ZERO } from "src/constants/bigNumber"
import { formatLockPeriod } from "src/pages/Stake/helpers"
import useXFerRate from "src/pages/Stake/hooks/useXFerRate"
import { AppState } from "src/state"
import { useFerroBoostPool } from "src/state/xFer/hooks"
import {
  formatNumber,
  getRawAmount,
  sanitizeStringForFN,
} from "src/utils/parseStringToBigNumber"

interface LockPeriodTooltipProps {
  pid: number
  lockPeriod: number
}

const TooltipContent = ({
  stakedAmount,
  tvl,
}: {
  stakedAmount: FixedNumber
  tvl: FixedNumber
}) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Box width="110px">{t("Staked xFER:")}</Box>
        <Box>{formatNumber(stakedAmount, 2, 6)}</Box>
      </Box>
      <Box display="flex" mt={1} alignItems="center">
        <Box width="110px">{t("TVL: ")}</Box>
        {formatNumber(tvl, 2, 6)}
      </Box>
    </Box>
  )
}

const LockPeriodText = ({ pid, lockPeriod }: LockPeriodTooltipProps) => {
  const rate = useXFerRate()
  const price = useSelector(
    (state: AppState) => state.application.ferro?.price ?? 0,
  )
  const { boostPoolData } = useFerroBoostPool()
  const stakedAmount =
    boostPoolData.poolInfo.find((pool) => pool.poolId === pid)?.stakes ||
    BIG_ZERO

  const formattedAmount = getRawAmount(stakedAmount, XFER.decimals)

  return (
    <Box ml={1}>
      <Tooltip
        arrow
        title={
          <TooltipContent
            stakedAmount={formattedAmount}
            tvl={formattedAmount
              .mulUnsafe(rate)
              .mulUnsafe(
                FixedNumber.from(sanitizeStringForFN(price.toString())),
              )}
          />
        }
      >
        <Box>
          <Text
            bold
            style={{
              textDecoration: "underline",
              textDecorationStyle: "dotted",
              textUnderlineOffset: "4px",
            }}
          >
            {formatLockPeriod(lockPeriod)}
          </Text>
        </Box>
      </Tooltip>
    </Box>
  )
}

export default LockPeriodText
